// extracted by mini-css-extract-plugin
export var defaultWrapper = "_hy-3";
export var downloadButton = "_hy-4";
export var fileContainer = "_hy-9 _hy-7";
export var fileContainerBase = "_hy-7";
export var fileContainerBaseSm = "_hy-a _hy-7";
export var fileContainerFixedHeight = "_hy-8 _hy-7";
export var fileContainerFixedHeightSm = "_hy-c _hy-a _hy-7";
export var fileContainerSm = "_hy-b _hy-a _hy-7";
export var fileInfo = "_hy-5";
export var fileInfoWidthRestricted = "_hy-6";
export var fileType = "_hy-1";
export var fileTypeName = "_hy-2";
export var fileTypeSm = "_hy-d _hy-1";
export var image = "_hy-0";
export var link = "_hy-f";
export var overflowEllipsis = "_hy-e";